import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: "How quickly can I start earning from my screen?",
      answer: "Most screen owners start earning within 48-72 hours of registration. Our team handles the technical setup, content approval, and advertiser matching automatically. You'll receive your first payment within 30 days of going live."
    },
    {
      question: "What type of screens work best?",
      answer: "Any digital display 32\" or larger works perfectly. TVs in restaurants, retail stores, gyms, waiting areas, and office lobbies perform exceptionally well. High-traffic locations with engaged audiences generate the highest revenue."
    },
    {
      question: "How do payments work?",
      answer: "Payments are processed automatically on the 1st of each month via direct deposit, PayPal, or check. You keep 70% of advertising revenue, with detailed earnings reports available 24/7 in your dashboard. Minimum payout is ₹500."
    },
    {
      question: "Can I control what ads appear on my screen?",
      answer: "Absolutely! You have full control over ad categories, can blacklist specific advertisers, and set content guidelines. All ads are pre-approved and family-friendly. You can also schedule your own content during specific hours."
    },
    {
      question: "What makes your platform better than competitors?",
      answer: "Our AI-powered matching system, real-time analytics, and 70% revenue share are industry-leading. We provide free technical support, guaranteed payments, and the largest network of premium advertisers. Most competitors offer 40-50% revenue share."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 section-separator">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-text-secondary">
            Everything you need to know about getting started
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-card">
              <button 
                className="w-full p-6 text-left flex items-center justify-between"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-lg font-semibold text-text-primary">{faq.question}</h3>
                <ChevronDownIcon 
                  className={`w-5 h-5 text-text-secondary transform transition-transform ${
                    openFAQ === index ? 'rotate-180' : ''
                  }`} 
                />
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-6">
                  <p className="text-text-secondary">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;